import React from 'react';
import { SignupLayout, SignupResumeView } from '../components';
import { useSignupResumeViewController } from '../controllers';

const SignupResumePage: React.FC = () => {
  const { outcome, goToLogin, retry } = useSignupResumeViewController();

  return (
    <SignupLayout>
      <SignupResumeView outcome={outcome} onLogIn={goToLogin} onRetry={retry} />
    </SignupLayout>
  );
};

export default SignupResumePage;
